import { Typography } from 'antd';
import React from 'react';
import { useSelector } from 'react-redux';
import { formatMoney } from '../../utils/money';
const { Text } = Typography;

/**
 * Số tiền theo ĐÚNG tiền của bản ghi (`currency`, mặc định USD - đơn hàng / thanh toán /
 * ví đều là USD). Trước đây lấy tiền của admin đang đăng nhập (users.currency) làm nhãn
 * cho số USD → sai (vd hiện "₫50" cho đơn 50 USD).
 */
const Currency = (props) => {
  const { value, style, currency } = props;
  const user = useSelector((state) => state.auth.authUser);
  return <Text style={style}>{formatMoney(value, currency, user?.language)}</Text>;
};

export default Currency;
